<template>
  <div class="clearfix spacing-md">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'HxTableResultCol'
}
</script>
